import script from "./post.vue?vue&type=script&setup=true&lang=js"
export * from "./post.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__